<p-dialog
    [visible]="visible()"
    (visibleChange)="visible.set($event)"
    header="Merge Patients"
    [style]="{ 'max-width': '700px', width: '100%' }"
    [closeOnEscape]="false"
    [closable]="false"
    [resizable]="false"
    [modal]="true"
    (onHide)="onHide.emit()">
    <merge-patients-selection [clearSelection]="false" [disabled]="processingService.running()"></merge-patients-selection>

    <merge-patients-processing></merge-patients-processing>

    <ng-template pTemplate="footer">
        <div class="flex flex-1 align-items-center">
            <p-button icon="pi pi-info-circle" [rounded]="true" [text]="true" (onClick)="mergeInfo.toggle($event)" />
            <p-overlayPanel #mergeInfo styleClass="w-full" [style]="{ 'max-width': '600px' }">
                <p class="m-0 mb-1 text-sm">Click on the <b>Swap</b> button to switch which profile you want to keep (the one that ends up on the left side will be kept).</p>
                <p class="m-0 mb-1 text-sm">Click on the <b>Merge</b> button to start the merge process.</p>
            </p-overlayPanel>
        </div>
        <p-button label="Close" (onClick)="visible.set(false)"></p-button>
    </ng-template>
</p-dialog>
